module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "20px"
    },
    on: {
      "click": function($event) {
        return _vm.goOff()
      }
    }
  }, [_c('van-icon', {
    attrs: {
      "name": "arrow-left",
      "size": "1.5em"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "600",
      "color": "#000"
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', [_c('div', [_c('p', {
    staticStyle: {
      "margin-top": "20px",
      "margin-left": "20px"
    }
  }, [_vm._v("购买记录")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.xuexi), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "biaoxiang"
    }, [_c('div', {
      staticClass: "xiaotanyi"
    }, [_c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(item.goods_name))])]), _vm._v(" "), _c('div', {
      staticClass: "xiaotaner"
    }, [_c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(item.price))])]), _vm._v(" "), _c('div', {
      staticClass: "xiaotansan"
    }, [_c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(item.pay_time))])]), _vm._v(" "), _c('div', {
      staticClass: "xiaotansi"
    }, [_c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(item.order_no))])])])
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xuexitou"
  }, [_c('div', {
    staticClass: "biaoxiang"
  }, [_c('div', {
    staticClass: "xiaotanyi",
    staticStyle: {
      "line-height": "50px"
    }
  }, [_c('span', [_vm._v("商品名称")])]), _vm._v(" "), _c('div', {
    staticClass: "xiaotaner",
    staticStyle: {
      "line-height": "50px"
    }
  }, [_c('span', [_vm._v("商品售价")])]), _vm._v(" "), _c('div', {
    staticClass: "xiaotansan",
    staticStyle: {
      "line-height": "50px"
    }
  }, [_c('span', [_vm._v("下单时间")])]), _vm._v(" "), _c('div', {
    staticClass: "xiaotansi",
    staticStyle: {
      "line-height": "50px"
    }
  }, [_c('span', [_vm._v("订单号")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5635a938"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/menu/PersonalCenter/MyPurchased.vue
// module id = 576
// module chunks = 0